import { supabase } from '@/integrations/supabase/client';
import { MealNote, DbMealNote, CreateMealNoteInput } from '@/types/mealNote';

export const mealNoteService = {
  async getMealNotesByDateRange(startDate: string, endDate: string): Promise<MealNote[]> {
    const { data, error } = await supabase
      .from('meal_notes')
      .select(`
        *,
        profiles!left(first_name)
      `)
      .gte('date', startDate)
      .lte('date', endDate)
      .order('date', { ascending: true });

    if (error) {
      console.error('Error fetching meal notes:', error);
      throw error;
    }

    return data?.map(transformDbMealNote) || [];
  },

  async createMealNote(input: CreateMealNoteInput & { userId: string }): Promise<MealNote> {
    const { data, error } = await supabase
      .from('meal_notes')
      .insert({
        date: input.date,
        note_text: input.noteText,
        meal_type: input.mealType || 'lunch',
        family_id: input.familyId || null,
        user_id: input.userId,
      })
      .select()
      .single();

    if (error) {
      console.error('Error creating meal note:', error);
      throw error;
    }

    return transformDbMealNote(data);
  },

  async deleteMealNote(id: string): Promise<void> {
    const { error } = await supabase
      .from('meal_notes')
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Error deleting meal note:', error);
      throw error;
    }
  },
};

function transformDbMealNote(dbMealNote: any): MealNote {
  return {
    id: dbMealNote.id,
    date: dbMealNote.date,
    noteText: dbMealNote.note_text,
    mealType: dbMealNote.meal_type as 'lunch' | 'dinner',
    familyId: dbMealNote.family_id,
    userId: dbMealNote.user_id,
    createdAt: dbMealNote.created_at,
    updatedAt: dbMealNote.updated_at,
    authorFirstName: dbMealNote.profiles?.first_name || 'Unknown',
  };
}